import { Component, Input, OnInit } from '@angular/core';
import { DataSharingService } from '../services/data-sharing.service';
import { StudentGet } from '../models/student-get';
import { StudentService } from '../services/student.service';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'payment-confirmation-online-class',
  templateUrl: './payment-confirmation-online-class.component.html',
  styleUrls: ['./payment-confirmation-online-class.component.css']
})
export class PaymentConfirmationOnlineClassComponent implements OnInit {
  onlineClassUrl = `${environment.onlineClassURL}`;
  attendees = '';
  student: StudentGet = new StudentGet();
  constructor(
    private _dataService: DataSharingService,
    private _studentService:  StudentService,
    private _router: Router,
  ) { }
  onRdioChange(item) {
    this.student.contactMethodId = item;
  }
  getData() {
    this.student = this._dataService.getCurrentStudent().student;
    this.attendees = this.student.firstName.concat(' ').concat(this.student.lastName);
    if (this.student.friendStudent ) {
      this.attendees = this.attendees.concat(' And ').concat(this.student.friendStudent.firstName).concat(' ').concat(this.student.friendStudent.lastName);
    }
  }
  print() {
    const bodyContents = document.getElementById('print-section').innerHTML;
    const popup = window.open('', '_blank', 'height=600,width=800,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popup.document.open();
    popup.document.write(`
      <html>
        <head>
          <title>Course Confirmation Details</title>
          <link rel="stylesheet" type="text/css" href="styles.css">
        </head>
        <body onload="window.print();window.close()">${bodyContents}</body>
      </html>`
    );
    popup.document.close();
  }
  update_email() {
    this._studentService.updateStudentEmail(this.student).subscribe(
      res => this.saveSuccessful(res),
      error => this.saveFailed(error),
      () => console.log('Student Email Updated!'));
  }
  update_contactMethod() {
        this._studentService.updateStudentContactMethod(this.student).subscribe(
          res => this.saveSuccessful(res),
          error => this.saveFailed(error),
          () => console.log('Student contact method updated!'));
  }

  saveSuccessful(result: any) {}
  saveFailed(result: any) {}
  topyx() {
    window.location.href = this.onlineClassUrl;
  }
  ngOnInit() {
    this.getData();
  }

}



// WEBPACK FOOTER //
// ./src/app/payment-confirmation-online-class/payment-confirmation-online-class.component.ts